var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDigging(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_dig_permit_shovel_transparent",
    "data-name": "Icon dig permit shovel transparent",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.505,
    height: 23.504,
    viewBox: "0 0 17.505 23.504",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17129",
    "data-name": "Rectangle 17129",
    className: "cls-3",
    width: 17.505,
    height: 23.504,
    transform: "translate(0 0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1853",
    "data-name": "Group 1853",
    className: "cls-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_870",
    "data-name": "Path 870",
    className: "cls-1",
    d: "M17.041,2.638C12.613-.2,12.6-.2,12,.174l-.01,0a4.244,4.244,0,0,0-1.1,2.878,3.046,3.046,0,0,0,.691,1.952L5.8,14.38,3.761,13.121a1,1,0,0,0-1.354.287C2.343,13.5.841,15.72.323,16.792a8.2,8.2,0,0,0,.151,4.974,2.487,2.487,0,0,0,1.239,1.547,3.674,3.674,0,0,0,2.064.093A7,7,0,0,0,7.81,21.328c.648-.973,1.984-3.2,2.039-3.294a1,1,0,0,0-.33-1.366L7.512,15.434l5.767-9.341a2.773,2.773,0,0,0,1.264.056.9.9,0,0,0,.165-.041A4.832,4.832,0,0,0,17.36,4a.994.994,0,0,0-.319-1.358M6.141,20.216A5.942,5.942,0,0,1,2.59,21.524c-.5-.469-.762-3.233-.458-3.859.267-.547.908-1.56,1.409-2.334l1.216.747-.417.676a1.012,1.012,0,0,0,.324,1.388,1,1,0,0,0,.7.126.983.983,0,0,0,.671-.458l.416-.677,1.159.717c-.445.743-1.1,1.8-1.474,2.366m8.1-16.05a.974.974,0,0,1-.793-.161L13.4,3.972a1.051,1.051,0,0,1-.474-.647,1.949,1.949,0,0,1,.054-.875c.539.329,1.264.788,2.023,1.262a1.933,1.933,0,0,1-.763.454"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigging);
export default __webpack_public_path__ + "static/media/digging.da49b0f1.svg";
export { ForwardRef as ReactComponent };